import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { createAdminNotification } from "../../../utils/notificationService";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { getVendorOrders } from "../../../api/pagination";
import { orderTerms } from "../../../data";
import { getDocByKeyValue, saveData } from "../../../firebase/utility";
const useVendorDetails = () => {
  const { user } = useSelector(state => state.auth)
  const { state } = useLocation();
  const { id } = useParams()
  const [vendorInfo, setVendorInfo] = useState(state ?? null);
  const [purchaseOrdersbyVendor, setPurchaseOrdersByVendor] = useState([]);
  const [loading, setLoading] = useState(true)
  const [notes, setNotes] = useState(vendorInfo?.notes ?? [])
  const [note, setNote] = useState("");
  const [loader, setLoader] = useState(false)
  const [poLoading, setPoLoading] = useState(false)

  const [billingData, setBillingData] = useState({
    company: "",
    first_name: "",
    last_name: "",
    address_1: "",
    address_2: "",
    country: "",
    city: "",
    state: "",
    phone: "",
    postcode: "",
    email: "",
    blind_dropship: false,
    terms: "",
    order_return_status: "",
    dba: [],
  });
  const addVendorNotes = () => {
    if (note !== "") {
      const newNote = {
        created_at: Date.parse(new Date()),
        status: "Order Updated",
        note: note,
        createdBy: {
          username: user?.username,
          role: 'vendor'
        }
      };
      setNotes((prevNotes) => [...prevNotes, newNote]);
      setNote("");
      toast.success("Please click update to store the notes")
    } else {
      toast.error("Please add note to proceed !");
    }
  };
  const handleUpdate = () => {
    setLoader(true)
    let updatedBillingArray = [...vendorInfo.billing];
    if (updatedBillingArray.length > 0) {
      updatedBillingArray[0] = billingData;
    }
    let obj = {
      billing: updatedBillingArray,
      _id: vendorInfo?._id,
      id: vendorInfo?.id,
      first_name: billingData?.first_name,
      last_name: billingData?.last_name,
      notes: notes,
      updatedAt: Date.parse(new Date()),
      updatedBy: { _id: user?._id || "", username: user?.username || "", email: user?.email || "" },
      createdAt: vendorInfo?.createdAt ?? null,
      createdBy: vendorInfo?.createdBy ?? null
    };
    let email = obj?.billing[0]?.email
    // checkVendorDomainAPI(email, vendorInfo?._id, (response) => {
    // if (response?.status === 400) {
    //   toast.error(response?.message);
    //   setLoader(false);
    //   return;
    // } else {
    saveData("Vendors", obj?._id, obj).then((res) => {
      if (res) {
        setLoader(false);
        toast.success("Vendor Updated Successfully !");
        createAdminNotification({
          title: "Vendor Updated",
          message: `Vendor ${obj?.name || "Vendor"} was updated by ${user?.username || "Admin"}`,
          category: "vendor",
          entityId: obj?._id,
          targetUrl: `/admin/vendors-details/${obj?._id}`,
          actor: user,
        }).catch(console.error);
      }
    });
    setVendorInfo({
      ...obj,
    });
    // }
    // })
  };
  useEffect(() => {
    if (vendorInfo?.quickbooks_id) {
      setPoLoading(true)
      getVendorOrders(vendorInfo?.quickbooks_id, (res) => {
        if (res?.data?.data?.length > 0) {
          setPurchaseOrdersByVendor(res?.data?.data);
          setPoLoading(false)
        } else {
          setPoLoading(false)
          setPurchaseOrdersByVendor([]);
        }
      })
    }
  }, [vendorInfo?.quickbooks_id]);
  useEffect(() => {
    if (id) {
      getDocByKeyValue("Vendors", "_id", id).then((res) => {
        if (res) {
          let data = res[0];
          let vendor = data?.billing[0]
          setLoading(false);
          setVendorInfo(data);
          setNotes(data?.notes ?? [])
          setBillingData({
            company: vendor?.company ?? "",
            first_name: vendor?.first_name ?? "",
            last_name: vendor?.last_name ?? "",
            address_1: vendor?.address_1 ?? "",
            address_2: vendor?.address_2 ?? "",
            country: vendor?.country ?? "",
            city: vendor?.city ?? "",
            state: vendor?.state ?? "",
            phone: vendor?.phone ?? "",
            postcode: vendor?.postcode ?? "",
            email: vendor?.email ?? "",
            blind_dropship: vendor?.blind_dropship ?? false,
            terms: orderTerms?.find((i) => i?.value === vendor?.terms)?.value ?? "",
            order_return_status: vendor?.order_return_status ?? "",
            dba: vendor?.dba ?? [],
          });
        }
      });
    }
  }, [id]);





  return {
    state,
    vendorInfo,
    setVendorInfo,
    note,
    setNote,
    billingData,
    setBillingData,
    addVendorNotes,
    handleUpdate,
    purchaseOrdersbyVendor,
    loading,
    notes,
    loader,
    poLoading,

  };
};
export default useVendorDetails;
